import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import { useAPIEditJenisMobil } from "../api/api-edit-jenis-mobil";
import { genElText } from "@components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";
import JenisMobilPhotoSection from "./jenis-mobil-photo-section";

const JenisMobilEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const {
    loading,
    data,
    setData,
    fetchDataOrCreateNew,
    error,
    pengecekanPhotos,
    loadingPhotos,
    handleOnConfirm,
  } = useAPIEditJenisMobil({ onConfirmed });

  // use effect section

  useEffect(() => {
    if (visible) {
      fetchDataOrCreateNew({ id: editorData.id });
    }
  }, [visible]);

  // handle ui event section

  // genereate editor element section

  const gambarFolderName =
    "jenis_mobil/" +
    (data.nama ? data.nama.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_") : data.id);

  const elNama = genElText({
    field: "nama",
    name: "Nama",
    value: data.nama ?? "",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "48rem" }}
      breakpoints={{ "960px": "85vw", "641px": "95vw" }}
      header={data.nama || "Edit Jenis Mobil"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <div className="col-start-center relative h-100 gap-3">
        {elNama}
        <div className="row-start-start w-100 gap-3">
          <div className="w-1/2">
            <JenisMobilPhotoSection
              field="gambar_depan"
              name="Foto Depan"
              data={data}
              setData={setData}
              photos={pengecekanPhotos?.gambar_depan || []}
              folderName={gambarFolderName}
              error={error}
            />
          </div>
          <div className="w-1/2">
            <JenisMobilPhotoSection
              field="gambar_belakang"
              name="Foto Belakang"
              data={data}
              setData={setData}
              photos={pengecekanPhotos?.gambar_belakang || []}
              folderName={gambarFolderName}
              error={error}
            />
          </div>
        </div>
        <div className="row-start-start w-100 gap-3">
          <div className="w-1/2">
            <JenisMobilPhotoSection
              field="gambar_kiri"
              name="Foto Kiri"
              data={data}
              setData={setData}
              photos={pengecekanPhotos?.gambar_kiri || []}
              folderName={gambarFolderName}
              error={error}
            />
          </div>
          <div className="w-1/2">
            <JenisMobilPhotoSection
              field="gambar_kanan"
              name="Foto Kanan"
              data={data}
              setData={setData}
              photos={pengecekanPhotos?.gambar_kanan || []}
              folderName={gambarFolderName}
              error={error}
            />
          </div>
        </div>
        {(loading || loadingPhotos) && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default JenisMobilEdit;
